module.exports = __webpack_public_path__ + "img/ball.05fb0ac0.png";